import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { DeleteLevelFourApi, UpdateLevelFourApi } from "./LevelFourAction";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { baseURL, headers } from "../../../../../global/api";
import MaterialTable from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


const ViewLevelFour = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"));
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
    };

    useEffect(() => {
        props.setHeading("View Level Four");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    title="View Level Four"
                    columns={[
                        {
                            title: 'Level 1', field: 'levelOneId.name', editable: 'never',
                            render: rowData => `${rowData.levelOneId.key} - ${rowData.levelOneId.name}`,
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                            title: 'Level 2', field: 'levelTwoId.levelTwoName', editable: 'never',
                            render: rowData => `${rowData.levelTwoId.allKey} - ${rowData.levelTwoId.levelTwoName}`,
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                            title: 'Level 3', field: 'levelThreeId.levelThreeName', editable: 'never',
                            render: rowData => `${rowData.levelThreeId.allLevlKey} - ${rowData.levelThreeId.levelThreeName}`,
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        { title: 'Code', field: 'allLevelKey', editable: 'never' },
                        {
                            title: 'Level 4 Name', field: 'levelFourName',
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                            title: 'Opening Balance', field: 'openingBalance',
                            render: rowData => `${rowData.openingBalance}/-`,
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                            title: 'O-B Type', field: 'openingBalanceType', editable: 'never',
                            render: rowData => {
                                return rowData.openingBalanceType === 1 ? 'Credit' : 'Debit';
                            }
                        },
                        // { title: 'Closing Balance', field: 'levelFourData.levelBalance', editable: 'never' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/levelFour/get_levelFour_details?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "landscape";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Level Four Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                // `${elt.levelFourData.levelOneId.key} - ${elt.levelFourData.levelOneId.name}`,
                                // `${elt.levelFourData.levelTwoId.allKey} - ${elt.levelFourData.levelTwoId.levelTwoName}`,
                                // `${elt.levelFourData.levelThreeId.allLevlKey} - ${elt.levelFourData.levelThreeId.levelThreeName}`,
                                elt.levelFourData.levelOneId.name,
                                elt.levelFourData.levelTwoId.levelTwoName,
                                elt.levelFourData.levelThreeId.levelThreeName,
                                elt.levelFourData.allLevelKey,
                                elt.levelFourData.levelFourName,
                                elt.levelFourData.openingBalance,
                                // elt.levelFourData.openingBalanceType,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Level Four Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Edit"),
                        isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Level Four Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.UpdateLevelFourApi(newData, oldData);
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteLevelFourApi(oldData.levelFourData._id);
                                }, 600);
                            }),
                    }}
                    icons={{
                        Edit: (props) => <EditIcon {...props} style={{ color: "#1B91BF" }} />,
                        Delete: (props) => <DeleteOutlineIcon {...props} style={{ color: "#DC3545" }} />
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        DeleteLevelFourApi: (levelFiveId) => dispatch(DeleteLevelFourApi(levelFiveId)),
        UpdateLevelFourApi: (newData, oldData) => dispatch(UpdateLevelFourApi(newData, oldData)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewLevelFour);